import React from 'react';

/**
 * Bordered, titled panel wrapping one chart/table/group of cards — the
 * source dashboards colour-code these per section (purple for Production
 * Incident, orange for Automation Coverage, etc.); `accent` picks that colour
 * via a CSS custom property rather than hardcoding a class per section.
 */
function Panel({ title, accent = 'purple', children, className = '' }) {
  return (
    <div className={`qk-panel qk-panel--${accent} ${className}`}>
      {title && <div className="qk-panel-title">{title}</div>}
      <div className="qk-panel-body">{children}</div>
    </div>
  );
}

export default Panel;
